import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { success } from "helper/icons";

export function SkipNoviceModal({ modalRef, onCloseSkipNoviceModal, skipNoviceHandler}) {
  return (
    <Modal extraClass={`pt-0`} headerClass="sticky top-6 left-100 z-50" iconPosition="right-0" ref={modalRef}>
        <div className="p-8 pb-0 items-center m-auto">
          <img src={success} alt="" className="w-12 h-12 mb-4 m-auto" />
          <span className="text-xl font-semibold text-gray-900">
            Are you sure about skipping the Noice Level?
          </span>
          <div className="flex gap-2 justify-center mt-4">
            <Button onClick={skipNoviceHandler}  label="Yes" width="w-[120px]" />
            <button className="w-[120px] border border-gray-300 rounded-md hover:bg-gray-300 py-2" onClick={onCloseSkipNoviceModal}>
              No
            </button>
          </div>
        </div>
    </Modal>
  );
}
